import {h, Fragment} from "preact"
import { useAppState, useLoadMore, useSizeOptions } from "@nosto/preact"
import { sizes, defaultConfig } from "../config"

export default function LoadMore({ pageSize }) {
    const { loading } = useAppState();
    const { to, total, size, from } = useSizeOptions(sizes, defaultConfig.serpSize)
    const { loadMore, href } = useLoadMore(defaultConfig.serpSize);

    return (
        <div className="ns-load-more center">
            <p className="ns-load-more__label">Viewing {total < to ? total : to} of {total}</p>
            {total > to && (
                <a
                    className="ns-load-more__button button button--primary"
                    style={ loading ? 'pointer-events: none; cursor: wait;' : '' }
                    onClick={loadMore}
                    href={href}
                >
                    Load More
                </a>
            )}
        </div>
   )
}